import { Box, Center, Img, Stack } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import LogoIcon from '../../assets/wrk_logo.png'

const MotionStack = motion.create(Stack)
const MotionBox = motion.create(Box)

const AuthWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Center bg="background.wrapper" w="100%" minH="100vh" px={{ base: '16px', md: 0 }} pt={10} pb={0}>
      <MotionStack
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        mb={10}
      >
        <MotionBox
          mb="32px"
          display="flex"
          justifyContent="center"
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.45, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        >
          <Img src={LogoIcon} alt="Logo" width="110px" height="55px" alignSelf="center" />
        </MotionBox>
        <MotionBox
          borderRadius="16px"
          p="20px"
          bg="solid.0"
          maxWidth="440px"
          width={{ base: '100%', md: '440px' }}
          boxShadow="0px 4px 32px rgba(93, 94, 203, 0.16)"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
        >
          {/* Container used by Firebase RecaptchaVerifier for MFA enrollment */}
          <div id="recaptcha-container" style={{ display: 'none' }} />
          {children}
        </MotionBox>
      </MotionStack>
    </Center>
  )
}

export default AuthWrapper
